import { Component, OnInit, Input, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';

import * as Highcharts from 'highcharts/highcharts';
import theme from 'highcharts/themes/brand-dark';
import solidGauge from 'highcharts/modules/solid-gauge';
import more from 'highcharts/highcharts-more';
import {ColorType, PaneBackgroundOptions, YAxisOptions, YAxisPlotLinesOptions, PlotAbandsOptions} from 'highcharts/highstock';
theme(Highcharts);
more(Highcharts);
solidGauge(Highcharts);

@Component({
  selector: 'app-gauge',
  templateUrl: './gauge.component.html',
  styleUrls: ['./gauge.component.css']
})

export class GaugeComponent implements OnInit, AfterViewInit {

  @Input() gaugeConfig: any;
  @Input() gaugeLabel: string;
  @Input() widgetSize: number;
  @Input() gaugeType: string;
  @Input() showValue: boolean = true;
  @Input() showTitle: boolean = true;
  
  Highcharts = Highcharts;
  chart: Highcharts.Chart;
  constructorType = 'chart';
  chartCallback: Highcharts.ChartCallbackFunction;
  chartOptions?: Highcharts.Options;
  updateFlag = false;

  IsInit = false;
  

  chartData: Highcharts.SeriesXrangeOptions;

  constructor() {
  }

  ngOnInit(): void {
    if(!this.gaugeConfig) return;
    this.init();
  }


  ngOnChanges(changes: SimpleChanges): void {
    
    // prevent the update from triggering by the first time.
    if (this.chartData?.data.length > 0) {
      this.updateGauge(this.gaugeConfig.value);
    }
  }

  public updateGauge(value: number): void {
    //console.log("updateGauge");
    this.gaugeConfig.value = value;
    if (this.chart && this.chart.series && value){
      this.chart.series[0].points[0].update(this.handleDecimal(value));
      // this.chart.series[0].points[0].update(this.gaugeConfig.value);
      this.updateFlag = true;
    }
  }

  ngAfterViewInit(): void {
    if(this.IsInit) this.addData();
  }

  init(): void {
    this.chartData = this.configureChartData();
    // let plotLines = this.configurePlotLines(this.gaugeConfig.plotLines);
    let plotLines = null;
    let plotBands = null;
    let yAxisColors = null;
    if (this.gaugeConfig.zoneColours){
      plotLines = this.convertPlotLinesByZoneColours(this.gaugeConfig.zoneColours);
      plotBands = this.convertPlotBandsByZoneColours(this.gaugeConfig.zoneColours);
      // let yAxisColors = this.configureYAxisColours(this.gaugeConfig.zoneColours);
      yAxisColors = this.configureYAxisColours(this.tranformZoneColours(this.gaugeConfig.zoneColours));
    }

    //console.log(plotBands);
    //this.showTitle = true;//this.gaugeConfig.showTitle;

    const paneOption: PaneBackgroundOptions = {
      // backgroundColor: '#606060',
      innerRadius: '60%',
      outerRadius: '100%',
      shape: 'arc',
      borderRadius:5
    };
    if (this.gaugeType == null){
      this.gaugeType = "speedometer";
    }
    if (this.gaugeType == "speedometer"){
      this.chartOptions = {
        chart: {
          type: 'gauge',
          alignTicks: false,
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          spacingBottom: 0,
          spacingTop: 0,
          spacingLeft: 0,
          spacingRight: 0,
          plotShadow: false,
          height: '100%',
          width: null,
          backgroundColor: "transparent"
        },
        title: {
          //text:''
          text: this.showTitle ? this.gaugeLabel : null,
          floating: false,
        },
        pane: {
          startAngle: -150,
          endAngle: 150
        },
        exporting: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },

        // the value axis
        yAxis: {
          min: this.gaugeConfig.min,
          max: this.gaugeConfig.max,
          stops: yAxisColors,

          lineColor: '#2caffe',
          tickColor: '#2caffe',
          minorTickColor: '#2caffe',
          offset: -25,
          lineWidth: 2,
          labels: {
              distance: -20,
              autoRotation: [-45, 45],
              style:{
                color: '#000',
                opacity: 0.8,
              }
          },
          tickLength: 5,
          minorTickLength: 5,
          endOnTick: false,

          title: {
              text: this.widgetSize == 3 ?  this.gaugeConfig.valueSuffix : null,
          },
          plotBands: plotBands
        },
        credits: {
          enabled: false
        }
      };
    }
    else if (this.gaugeType == "solid" ){
      this.chartOptions = {
        chart: {
          type: 'solidgauge',
          backgroundColor: "transparent",
          height: '100%',
          // Edit chart spacing
          spacingBottom: 0,
          spacingTop: 0,
          spacingLeft: 0,
          spacingRight: 0,
          width: null
        },
        title: {
          text: this.showTitle ? this.gaugeLabel : "",
          floating: true,
        },
        pane: {
          center: ['50%', '75%'],
          size: '100%',
          startAngle: -90,
          endAngle: 90,
          background:[paneOption]
        },
        exporting: {
          enabled: false
        },

        tooltip: {
          enabled: false
        },
        // the value axis
        yAxis: {
          stops: yAxisColors,
          min: this.gaugeConfig.min,
          max: this.gaugeConfig.max,
          /*title: {
            text: this.showTitle ? this.gaugeLabel : "",
            style: {
              fontSize: '1.8em'//this.getTitleLabelFontSize(this.widgetSize)
            },
            y:-130
            //y: this.getTitleLabelYAxis(this.widgetSize)
          },*/
          plotLines:plotLines,
          tickWidth: 0,
          lineWidth: 0,
          minorTickInterval: null,
          tickAmount: 2,
          labels: {
            enabled: true,//this.shouldDataLabelEnabled(this.widgetSize),
            align: 'center',
            style:{
              fontSize: '1em',
              textAlign: 'center',
            },
            y: 16
          },
        },
        plotOptions: {
          //gauge value config
          solidgauge: {
            dataLabels: {
              y: this.getDataLabelYAxis(this.widgetSize),
              color: '#FFF',
              borderWidth: 0,
              useHTML: true
            },
          }

        },
        credits: {
          enabled: false
        }
      };
    }
    this.chartCallback = chart => {
      this.chart = chart;
    };

    this.IsInit = true;
  }

  configureYAxisColours(colorsObj): Array<[number, ColorType]> {
    if(colorsObj && colorsObj.length > 0){
      let options: Array<[number, ColorType]> = [];
      for (let index = 0; index < colorsObj.length; index++) {
        const obj = colorsObj[index];
        const maxInPercentage = this.getPercentage(obj[0], this.gaugeConfig.max)
        obj[0] = maxInPercentage;
        options.push(obj);
      }
      return options;
    }else{
      return null;
    }
  }

  configurePlotLines(plotLines: [any]): Array<YAxisPlotLinesOptions> {
    if(plotLines && plotLines.length > 0){
      let options: Array<YAxisPlotLinesOptions> = [];
      for (let index = 0; index < plotLines.length; index++) {
        options.push(plotLines[index]);
      }
      return options;
    }else{
      return null;
    }
  }

  convertPlotLinesByZoneColours(zoneColors: [any]): Array<YAxisPlotLinesOptions>{
    let options: Array<YAxisPlotLinesOptions> = [];
    if(zoneColors && zoneColors.length > 0){
      for (let index = 0; index < zoneColors.length; index++) {
        const obj = zoneColors[index];
        if(!obj.showPlotLine) continue;
  
        const plotLine:YAxisPlotLinesOptions = {
          // color: "grey",
          color: obj.colour,
          dashStyle: "LongDash",
          width: 1,
          value: obj.max,
          zIndex: 10
        }
        options.push(plotLine);
    }
      return options;
    }
    return null;
  }

  convertPlotBandsByZoneColours(zoneColors: [any]): Array<any>{
    let options: Array<any> = [];
    if(zoneColors && zoneColors.length > 0){
      for (let index = 0; index < zoneColors.length; index++) {
        const obj = zoneColors[index];  
        const plotLine = {
          color: obj.colour,
          from: obj.min,
          to: obj.max
        }
        options.push(plotLine);
    }
      return options;
    }
    return null;
  }

  configureChartData(): Highcharts.SeriesXrangeOptions {
    if (this.gaugeType == "speedometer"){
      return {
        name: this.widgetSize == 3 ? this.gaugeLabel : null,
        data: [],
        type: undefined,
        dataLabels: {
          enabled:this.shouldDataLabelEnabled(this.widgetSize),
          format: `<span style="color:#2caffe">{y} ${this.gaugeConfig.valueSuffix}</span>`,
          backgroundColor: {
                linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1
                },
                stops: [
                    [0, 'var(--highcharts-neutral-color-20, #ddd)'],
                    [1, 'var(--highcharts-background-color, #fff)']
                ]
            },
        },
        tooltip: {
          valueSuffix: this.gaugeConfig.valueSuffix
        }
      };
    }else{
      return {
        name: this.widgetSize <= 3 ? this.gaugeLabel : null,
        data: [],
        type: undefined,
        dataLabels: {
          enabled: this.shouldDataLabelEnabled(this.widgetSize),
          format: this.showTitle ? 
            '<div style="text-align:center">' +
            `<span style="font-size:${this.getValueFontSize(this.widgetSize)}em">{y}</span><br/>` +
            `<span style="font-size:${this.getValueSuffixSize(this.widgetSize)}em;opacity:0.4">${this.gaugeConfig.valueSuffix}</span>` +
            '</div>' : ""
        },
        tooltip: {
          valueSuffix: this.gaugeConfig.valueSuffix
        }
      };
    }
  }

  getPercentage(val, max):number{
    try {
      return val / max;
    } catch (error) {
      console.error(error);
      return null;
    }
  } 

  shouldDataLabelEnabled(size):boolean{
    return size != 1;
  } 

  getTitleLabelFontSize(size): string{
    switch (size) {
      case 1: return '1em';
      case 2: return "1em";
      case 3: return "1.5em";
      case 4: return "2em";
      case 5: return "2em";
      default: return "5em";
    }
  }

  getTitleLabelYAxis(size): number{
    switch (size) {
      case 1: return 35;
      case 2: return 85;
      case 3: return 110;
      case 4: return 130;
      case 5: return 100
      default: return -35;
    }
  }

  getDataLabelYAxis(size): number{
    switch (size) {
      case 1: return 0;
      case 2: return -15;
      case 3: return -35;
      case 4: return -40;
      default: return -35;
    }
  }

  getValueFontSize(size): number{
    switch (size) {
      case 1: return 0;
      case 2: return 1.10;
      case 3: return 1.8;
      case 4: return 2;
      case 5: return 2.2;
      case 6: return 2.3;
      default: return 2.4;
    }
  }

  getValueSuffixSize(size): number{
    switch (size) {
      case 1: return 0;
      case 2: return 0.8;
      case 3: return 1.05;
      case 4: return 1.25;
      case 5: return 1.3;
      case 6: return 1.4;
      default: return 1.5;
    }
  }

  addData(): void {    
    this.chartData.zones = [];
    this.chartData.data.push({y: this.handleDecimal(this.gaugeConfig.value)} as any);
    // this.chartData.data.push({y: this.gaugeConfig.value} as any);
    // add data group by speed to chart
    if (this.chart){
      this.chart.addSeries(this.chartData);
    }
  }

  tranformZoneColours(zoneColours):any[]{
    let newZoneColours = [];
    for (const zoneColour of zoneColours) {
      newZoneColours.push([zoneColour.max,zoneColour.colour ]);
    }
    return newZoneColours;
  }

  handleDecimal(gaugeVal): number{
    try {
      return Number(gaugeVal.toFixed(4));
    } catch (error) {
      return null;
    }
  }
}
